import { $ as e, B as t, C as n, D as r, F as i, G as a, I as o, L as s, R as c, S as l, U as u, _ as d, d as f, f as p, g as m, h, i as g, m as _, nt as v, ot as y, p as b, q as x, rt as S, t as C, v as w, w as T, y as ee, z as E } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as D, t as O } from "./i18n-lite-BcmwMblk.js";
import { t as k } from "./normalize-props-DNjMoRjC.js";
import { n as A, r as j, t as M } from "./Cross.ce-B3B4wiAB.js";
import { t as N } from "./Stepper.ce-C5_sKJn0.js";
import { t as P } from "./stepper-B46XPcuc.js";
//#region src/webcomponents/analyse-mails-phishing/locales/de-AT.json
var F = {}, I = {}, L = {}, R = {}, z = { "analyse-mails-phishing": {
	continue: "Continuer",
	feedbackSrOnly: "Vous pouvez cliquer sur Continuer pour afficher le prochain mail.",
	feedbackTitle: {
		correct: "Bien joué",
		incorrect: "Ce n’est pas ça"
	},
	recipient: "{{srOnly}}{{recipient}}",
	recipientSrOnly: "Destinataire\xA0: ",
	sender: "{{srOnly}}{{sender}}",
	senderSrOnly: "Expéditeur\xA0: ",
	subject: "{{srOnly}}{{subject}}",
	subjectSrOnly: "Sujet\xA0: ",
	to: "À moi"
} }, B = { "analyse-mails-phishing": {
	continue: "Continuer",
	subject: "{{srOnly}}{{subject}}",
	subjectSrOnly: "Sujet\xA0: ",
	sender: "{{srOnly}}{{sender}}",
	senderSrOnly: "Expéditeur\xA0: ",
	recipient: "{{srOnly}}{{recipient}}",
	recipientSrOnly: "Destinataire\xA0: ",
	to: "À moi",
	feedbackTitle: {
		correct: "Bien joué",
		incorrect: "Ce n’est pas ça"
	},
	feedbackSrOnly: "Vous pouvez cliquer sur Continuer pour afficher le prochain mail."
} }, V = {}, H = {}, U = "data:image/svg+xml,%3csvg%20width='41'%20height='41'%20viewBox='0%200%2041%2041'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2033.5484C9.02496%2031.6445%209.79268%2029.8271%2011.1371%2028.4893C12.4815%2027.1515%2014.2944%2026.4009%2016.1837%2026.3999H24.8163C26.7056%2026.4009%2028.5185%2027.1515%2029.8629%2028.4893C31.2073%2029.8271%2031.975%2031.6445%2032%2033.5484C28.8446%2036.4141%2024.7476%2038%2020.5%2038C16.2524%2038%2012.1554%2036.4141%209%2033.5484ZM26.9744%2015.525C26.9744%2016.8155%2026.5947%2018.077%2025.8833%2019.1501C25.1719%2020.2231%2024.1607%2021.0594%2022.9776%2021.5533C21.7946%2022.0471%2020.4928%2022.1763%2019.2369%2021.9246C17.981%2021.6728%2016.8274%2021.0514%2015.9219%2020.1388C15.0164%2019.2263%2014.3998%2018.0637%2014.15%2016.7979C13.9002%2015.5322%2014.0284%2014.2203%2014.5184%2013.028C15.0085%2011.8357%2015.8383%2010.8166%2016.903%2010.0997C17.9677%209.38268%2019.2195%209%2020.5%209C22.2171%209%2023.8639%209.68745%2025.0781%2010.9111C26.2923%2012.1348%2026.9744%2013.7944%2026.9744%2015.525Z'%20fill='white'/%3e%3cpath%20d='M36.2655%2033.5758C38.3699%2031.0459%2039.8335%2028.0469%2040.5326%2024.8323C41.2316%2021.6177%2041.1455%2018.2822%2040.2815%2015.1079C39.4175%2011.9336%2037.8011%209.0139%2035.569%206.59581C33.3368%204.17772%2030.5547%202.33238%2027.4578%201.21587C24.3609%200.0993725%2021.0405%20-0.255438%2017.7774%200.181459C14.5142%200.618355%2011.4044%201.83411%208.71099%203.72586C6.01756%205.61762%203.81975%208.12973%202.30349%2011.0497C0.787232%2013.9696%20-0.00287585%2017.2115%207.86538e-06%2020.5011C0.00111445%2025.2832%201.6877%2029.9122%204.7638%2033.5758L4.7345%2033.6007C4.83707%2033.7237%204.9543%2033.8291%205.0598%2033.9506C5.19168%2034.1014%205.33382%2034.2435%205.47009%2034.3899C5.88039%2034.835%206.3024%2035.2625%206.74493%2035.6637C6.87974%2035.7866%207.01895%2035.9008%207.15522%2036.018C7.62413%2036.4221%208.10623%2036.8057%208.6059%2037.1629C8.67038%2037.2068%208.72899%2037.264%208.79347%2037.3093V37.2918C12.2254%2039.7049%2016.3196%2041%2020.5161%2041C24.7127%2041%2028.8068%2039.7049%2032.2388%2037.2918V37.3093C32.3033%2037.264%2032.3604%2037.2068%2032.4263%2037.1629C32.9246%2036.8042%2033.4081%2036.4221%2033.877%2036.018C34.0133%2035.9008%2034.1525%2035.7852%2034.2873%2035.6637C34.7298%2035.261%2035.1519%2034.835%2035.5622%2034.3899C35.6984%2034.2435%2035.8391%2034.1014%2035.9725%2033.9506C36.0765%2033.8291%2036.1952%2033.7237%2036.2978%2033.5992L36.2655%2033.5758ZM20.5147%208.78808C21.8188%208.78808%2023.0937%209.1745%2024.1781%209.89846C25.2625%2010.6224%2026.1076%2011.6514%2026.6067%2012.8553C27.1058%2014.0592%2027.2364%2015.384%2026.982%2016.662C26.7275%2017.9401%2026.0995%2019.1141%2025.1773%2020.0355C24.2551%2020.9569%2023.0802%2021.5844%2021.8011%2021.8387C20.522%2022.0929%2019.1961%2021.9624%2017.9912%2021.4637C16.7864%2020.9651%2015.7565%2020.1206%2015.032%2019.0371C14.3074%2017.9536%2013.9207%2016.6798%2013.9207%2015.3767C13.9207%2013.6293%2014.6154%2011.9534%2015.852%2010.7178C17.0886%209.48224%2018.7658%208.78808%2020.5147%208.78808ZM8.80226%2033.5758C8.82768%2031.6534%209.60958%2029.8182%2010.9788%2028.4674C12.348%2027.1165%2014.1945%2026.3586%2016.1187%2026.3576H24.9107C26.8349%2026.3586%2028.6813%2027.1165%2030.0505%2028.4674C31.4197%2029.8182%2032.2016%2031.6534%2032.2271%2033.5758C29.0134%2036.4694%2024.8407%2038.0708%2020.5147%2038.0708C16.1886%2038.0708%2012.016%2036.4694%208.80226%2033.5758Z'%20fill='%232F80ED'/%3e%3c/svg%3e", W = "data:image/svg+xml,%3csvg%20width='8'%20height='4'%20viewBox='0%200%208%204'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%200L3.53%203.38803L7.06%200H0Z'%20fill='black'/%3e%3c/svg%3e", G = /*#__PURE__*/ C(/* @__PURE__ */ T({
	__name: "MailElement.ce",
	props: {
		block: {
			type: Boolean,
			default: !1
		},
		path: { type: String }
	},
	setup(e) {
		let { selectedPath: n, correct: o, paths: s, pathToIndex: l } = r("store"), d = u("el"), h = _(() => n.value === e.path), g = _(() => l.value[e.path]), y = _(() => h.value || n.value === void 0 && g.value === 0);
		function b() {
			n.value = e.path;
		}
		function C() {
			g.value !== 0 && (n.value = s.value[g.value - 1]);
		}
		function w() {
			g.value !== s.value.length - 1 && (n.value = s.value[g.value + 1]);
		}
		return a(() => {
			h.value && d.value.focus();
		}), (n, r) => (i(), m(t(e.block ? "div" : "span"), {
			ref_key: "el",
			ref: d,
			class: S(["mail-element", {
				"mail-element--correct": h.value && v(o),
				"mail-element--incorrect": h.value && !v(o)
			}]),
			role: "option",
			"aria-selected": h.value,
			tabindex: y.value ? 0 : -1,
			onClick: r[0] ||= (e) => b(),
			onKeydown: [
				r[1] ||= f(p((e) => b(), ["stop", "prevent"]), ["space"]),
				r[2] ||= f(p((e) => C(), ["stop", "prevent"]), ["up", "left"]),
				r[3] ||= f(p((e) => w(), ["stop", "prevent"]), ["down", "right"])
			]
		}, {
			default: x(() => [c(n.$slots, "default")]),
			_: 3
		}, 40, [
			"class",
			"aria-selected",
			"tabindex"
		]));
	}
}), [["styles", [".mail-element{cursor:pointer;font-weight:inherit;background-color:#0000;border:1px solid #cdd1d9;border-radius:4px;padding:0 2px}.mail-element--correct{background-color:#54c590}.mail-element--incorrect{background-color:#e4766f}"]]]), K = {
	class: "mail",
	role: "listbox"
}, q = ["arial-level"], J = { class: "sr-only" }, Y = { class: "mail-header" }, X = ["src"], Z = { class: "mail-header__content" }, Q = { class: "sr-only" }, te = { class: "mail-header__from-name" }, ne = { class: "mail-header__from-address" }, re = { class: "mail-header__to" }, ie = { class: "sr-only" }, ae = ["src"], oe = {
	key: 0,
	class: "mail__paragraph"
}, se = {
	key: 1,
	class: "mail__button"
}, ce = {
	key: 0,
	class: "sr-only"
}, le = /*#__PURE__*/ C(/* @__PURE__ */ T({
	__name: "AnalyseMailsPhishing.ce",
	props: {
		titleLevel: { type: Number },
		mails: { type: Array }
	},
	setup(t, { expose: r }) {
		let a = ee(t, ["mails"]), { t: c } = D(), f = e(0), p = e(), g = u("container"), S = _(() => a.titleLevel ?? 2), C = _(() => t.mails[f.value]), T = _(() => p.value !== void 0), O = _(() => C.value.answers.includes(p.value)), k = _(() => O.value ? c("analyse-mails-phishing.feedbackTitle.correct") : c("analyse-mails-phishing.feedbackTitle.incorrect")), P = _(() => O.value ? C.value.correctFeedback : C.value.incorrectFeedback), F = _(() => O.value && f.value < t.mails.length - 1), I = _(() => C.value.body.map((e, t) => {
			if (e.type === "paragraph") return {
				...e,
				content: e.content.map((e, n) => ({
					text: e,
					path: `body[${t}][${n}]`
				}))
			};
			if (e.type === "button") return {
				...e,
				path: `body[${t}]`
			};
		})), L = _(() => [
			"subject",
			"from.name",
			"from.address",
			...I.value.flatMap((e) => {
				if (e.type === "paragraph") return e.content.map(({ path: e }) => e);
				if (e.type === "button") return [e.path];
			})
		]), R = _(() => Object.fromEntries(L.value.map((e, t) => [e, t])));
		o("store", {
			selectedPath: p,
			correct: O,
			paths: L,
			pathToIndex: R
		});
		function z() {
			f.value++, p.value = void 0, g.value.focus();
		}
		function B() {
			f.value = 0, p.value = void 0;
		}
		return r({ reset: B }), (e, r) => {
			let a = E("i18n");
			return i(), w("div", {
				ref_key: "container",
				ref: g,
				class: "analyse-mails-phishing",
				tabindex: "-1"
			}, [
				n(N, {
					step: f.value,
					"steps-count": t.mails.length
				}, null, 8, ["step", "steps-count"]),
				h("div", K, [
					n(G, {
						path: "subject",
						block: !0
					}, {
						default: x(() => [h("div", {
							class: "mail__subject",
							role: "heading",
							"arial-level": S.value
						}, [n(a, { t: "analyse-mails-phishing.subject" }, {
							srOnly: x(() => [h("span", J, y(e.$t("analyse-mails-phishing.subjectSrOnly")), 1)]),
							subject: x(() => [l(y(C.value.subject), 1)]),
							_: 1
						})], 8, q)]),
						_: 1
					}),
					h("div", Y, [h("img", {
						src: v(U),
						alt: ""
					}, null, 8, X), h("div", Z, [h("div", null, [n(a, { t: "analyse-mails-phishing.sender" }, {
						srOnly: x(() => [h("span", Q, y(e.$t("analyse-mails-phishing.senderSrOnly")), 1)]),
						sender: x(() => [
							n(G, { path: "from.name" }, {
								default: x(() => [h("span", te, y(C.value.from.name), 1)]),
								_: 1
							}),
							r[1] ||= l(),
							n(G, { path: "from.address" }, {
								default: x(() => [h("span", ne, "<" + y(C.value.from.address) + ">", 1)]),
								_: 1
							})
						]),
						_: 1
					})]), h("div", re, [n(a, { t: "analyse-mails-phishing.recipient" }, {
						srOnly: x(() => [h("span", ie, y(e.$t("analyse-mails-phishing.recipientSrOnly")), 1)]),
						recipient: x(() => [l(y(e.$t("analyse-mails-phishing.to")) + " ", 1), h("img", {
							src: v(W),
							alt: ""
						}, null, 8, ae)]),
						_: 1
					})])])]),
					(i(!0), w(b, null, s(I.value, (e, t) => (i(), w(b, { key: t }, [e.type === "paragraph" ? (i(), w("p", oe, [(i(!0), w(b, null, s(e.content, ({ path: e, text: t }, r) => (i(), w(b, { key: r }, [r === 0 ? d("", !0) : (i(), w(b, { key: 0 }, [l(y(" "))], 64)), n(G, { path: e }, {
						default: x(() => [l(y(t), 1)]),
						_: 2
					}, 1032, ["path"])], 64))), 128))])) : d("", !0), e.type === "button" ? (i(), w("div", se, [n(G, { path: e.path }, {
						default: x(() => [l(y(e.name), 1)]),
						_: 2
					}, 1032, ["path"])])) : d("", !0)], 64))), 128))
				]),
				n(j, { "display-feedback": T.value }, {
					icon: x(() => [O.value ? (i(), m(A, {
						key: 0,
						class: "feedback-icon"
					})) : (i(), m(M, {
						key: 1,
						class: "feedback-icon"
					}))]),
					title: x(() => [l(y(k.value), 1)]),
					content: x(() => [l(y(P.value) + " ", 1), F.value ? (i(), w("span", ce, y(e.$t("analyse-mails-phishing.feedbackSrOnly")), 1)) : d("", !0)]),
					_: 1
				}, 8, ["display-feedback"]),
				F.value ? (i(), w("button", {
					key: 0,
					class: "continue-button",
					onClick: r[0] ||= (e) => z()
				}, y(e.$t("analyse-mails-phishing.continue")), 1)) : d("", !0)
			], 512);
		};
	}
}), [["styles", ["*{color:#122647;font-family:Nunito,Roboto,sans-serif}p{margin:0}.analyse-mails-phishing{flex-direction:column;gap:24px;display:flex}.mail{background:#f4f5f7;border-radius:8px;flex-direction:column;align-items:start;gap:12px;padding:16px;display:flex}.mail__subject{font-size:18px}.mail-header{align-items:center;gap:16px;display:flex}.mail-header__content{flex-direction:column;gap:4px;display:flex}.mail-header__from-name{font-size:15px;font-weight:700}.mail-header__from-address{color:#757575;font-size:12px}.mail-header__to{color:#818488;align-items:center;gap:6px;font-size:12px;font-weight:500;display:flex}.mail__paragraph{font-size:14px;line-height:24px}.mail__button{color:#253858;text-align:center;background-color:#fff;border:1px solid #cdd1d9;border-radius:8px;padding:8px 24px;font-size:14px;font-weight:700}.mail-element--correct .mail-header__from-address,.mail-element--incorrect .mail-header__from-address{color:#122647}.feedback-icon{width:16px;height:16px}.continue-button{color:#fff;cursor:pointer;background-color:#253858;border-style:none;border-radius:8px;align-self:center;padding:8px 24px;font-size:14px;font-weight:700}@media only screen and (width<=576px){.analyse-mails-phishing{gap:12px}.mail__subject{font-size:16px}.mail__button{padding:8px 12px}}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}"]]]);
O.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": F,
	"./locales/en.json": I,
	"./locales/es-419.json": L,
	"./locales/es.json": R,
	"./locales/fr-BE.json": z,
	"./locales/fr.json": B,
	"./locales/it.json": V,
	"./locales/nl.json": H
})), P();
var $ = g(le, { configureApp(e) {
	O.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(O);
} });
$.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: k(e.titleLevel)
}), window.customElements.define("analyse-mails-phishing", $);
//#endregion
